export const statusColors: Record<string, string> = {
  pending: 'bg-muted text-muted-foreground',
  running: 'bg-info-muted text-info',
  evaluating: 'bg-info-muted text-info',
  completed: 'bg-success-muted text-success',
  failed: 'bg-destructive-muted text-destructive',
  cancelled: 'bg-warning-muted text-warning',
};

const STATUS_LABELS: Record<string, string> = {
  pending: 'pending',
  running: 'simulating',
  evaluating: 'evaluating',
  completed: 'completed',
  failed: 'failed',
  cancelled: 'cancelled',
};

export const StatusBadge = ({ status }: { status: string }) => (
  <span
    data-testid={`status-badge-${status}`}
    className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${statusColors[status] ?? ''}`}
  >
    {STATUS_LABELS[status] ?? status}
  </span>
);
